/* eslint-disable */
import { createStyles, makeStyles } from "@material-ui/core";
import type { Theme, AccordionClassKey, AccordionSummaryClassKey } from "@material-ui/core";
import type { ClassNameMap } from "@material-ui/styles";

const PREFIX = "basf-accordion";

export const rootClasses: Partial<ClassNameMap<AccordionClassKey>> = {
  expanded: `${PREFIX}--expanded`,
};

export const summaryClasses: Partial<ClassNameMap<AccordionSummaryClassKey>> = {
  content: `${PREFIX}-summary--content`,
  expanded: `${PREFIX}-summary--expanded`,
  expandIcon: `${PREFIX}-summary--expand-icon`,
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: "1px solid rgb(216, 216, 216)",
      boxShadow: "none",

      "&:active": {
        border: "1px solid #000",
      },

      "&::before": {
        content: "none",
      },
      [`&.${rootClasses.expanded}`]: {
        margin: 0,
      },

      "& .blue": {
        color: "#3860be",
      },
    },
    summary: {
      fontSize: "14px",
      fontWeight: 700,

      padding: "12px 15px 12px 20px",
      display: "flex",
      flexDirection: "row-reverse",
      gap: "5px",

      [`&.${summaryClasses.expanded!}`]: {
        minHeight: "unset",
      },

      [`& .${summaryClasses.content!}`]: {
        margin: 0,
        justifyContent: "space-between",
      },
      [`& .${summaryClasses.expandIcon!}`]: {
        margin: 0,
        padding: 0,
        transform: "scale(0.6)",
        filter: "drop-shadow(0px 0px 1px black)",
      },
    },
    details: {
      backgroundColor: "#F8F8F8",
      flexDirection: "column",
      padding: 0,
    },
    detailsContent: {
      fontSize: "13px",
      lineHeight: "20px",
      padding: "15px 20px 0 20px",
    },

    subContainer: {
      display: "flex",
      flexDirection: "column",
      margin: "5px 20px 5px 40px",
    },
    subSummary: {
      marginTop: "5px",
      justifyContent: "space-between",
      display: "flex",
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "bold",
      "& .blue": {
        fontSize: "14px",
        marginRight: "-5px",
      },
    },
    subDetails: {
      fontSize: "11px",
      lineHeight: "16px",
      paddingTop: "20px",
    },
    subLink: {
      color: "#656565",
      cursor: "pointer",
      textDecoration: 'underline',
    },

    vendorDetails: {
      color: "#3860be",
      padding: "5px 0 2px 20px",
      fontWeight: 'bold',
      fontSize: '13px',
      cursor: 'pointer',
      
    },
  })
);
